module.exports = __webpack_public_path__ + "static/media/jcb.d9115a1f.png";